"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var entity_search_item_1 = require("../../model/entity-search-item");
var entity_service_1 = require("../../service/api/entity.service");
var sis_single_select_entity_search_settings_component_1 = require("../settings/sis-single-select-entity-search-settings.component");
var sis_entity_search_component_1 = require("../sis-entity-search/sis-entity-search.component");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var SisSingleSelectEntitySearchComponent = /** @class */ (function (_super) {
    __extends(SisSingleSelectEntitySearchComponent, _super);
    function SisSingleSelectEntitySearchComponent(kbService, httpEntitySearchService, currentLanguageProvider, cd, languageService) {
        var _this = _super.call(this, kbService, httpEntitySearchService) || this;
        _this.kbService = kbService;
        _this.httpEntitySearchService = httpEntitySearchService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.cd = cd;
        _this.languageService = languageService;
        _this.entityChange = new core_1.EventEmitter();
        return _this;
    }
    SisSingleSelectEntitySearchComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['filterableEntity']) { // case, when user want to change filterable field
            this.entitySearchCtrl.disable();
            this.reset();
            var nameMetaFieldIds$ = this.kbService.getNameMetaFieldIds(changes['filterableEntity'].currentValue, this.kbPrefix || undefined);
            var metaFields$ = this.kbService.getMetaFields(changes['filterableEntity'].currentValue, this.kbPrefix || undefined);
            var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
            var inputLanguages$ = this.languageService.getInputLanguages();
            var defaultLanguage$ = this.languageService.getDefaultLanguage();
            Observable_1.Observable.combineLatest(metaFields$, nameMetaFieldIds$, currentLanguage$, inputLanguages$, defaultLanguage$)
                .publishReplay(1).refCount()
                .subscribe(function (_a) {
                var metaFields = _a[0], nameMetaFieldIds = _a[1], currentLanguage = _a[2], inputLanguages = _a[3], defaultLanguage = _a[4];
                if (inputLanguages.some(function (inputLanguage) { return inputLanguage.getId() === currentLanguage.getId(); })) {
                    _this.currentLanguageId = currentLanguage.getId();
                }
                else {
                    _this.currentLanguageId = defaultLanguage.getId();
                }
                _this.nameFieldIds = nameMetaFieldIds;
                _this.initSortingOption(metaFields);
                _this.checkingFilterFieldsTypes(metaFields);
                _this.initFilteredCategoryInstanceFieldName(metaFields);
                _this.initEntitySearchInputFilterChangeHandler(true);
                _this.selectedEntity = null;
                changes['value'] && _this.initSelectedEntity(changes['value'].currentValue);
                _this.entitySearchCtrl.setValue('');
                _this.entitySearchCtrl.enable();
            });
        }
        else if (changes['value'] && !changes['value'].currentValue) { // case, when user want to reset single entity field
            this.selectedEntity = null;
            this.entitySearchCtrl.setValue('', { emitEvent: false });
        }
    };
    SisSingleSelectEntitySearchComponent.prototype.initSelectedEntity = function (selectedValue) {
        var _this = this;
        if (selectedValue !== undefined && selectedValue !== null && selectedValue.length > 0) {
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            filterBuilder.in(this.categoryIdentityFieldSystemName, selectedValue);
            this.httpEntitySearchService.loadEntitySearchItems(this.filterableEntity, this.filterFields, this.multilingualFields, this.nameFieldIds, this.categoryIdentityFieldSystemName, this.currentLanguageId, new idm_de_core_frontend_1.PagingOptions(0, 1), null, filterBuilder.build(), null, this.kbPrefix)
                .pipe(operators_1.takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
                if (data.getData().length > 0) {
                    var entity = data.getData()[0];
                    _this.selectedEntity = new entity_search_item_1.EntitySearchItem(entity.id, entity.displayName);
                    _this.entitySearchCtrl.setValue(entity.displayName);
                }
            });
        }
    };
    SisSingleSelectEntitySearchComponent.prototype.onEntitySelect = function (entity) {
        this.selectedEntity = entity;
        this.entitySearchCtrl.setValue(entity.displayName);
        this.entitiesInput.nativeElement.value = entity.displayName;
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.entityChange.emit(entity.entity);
        this.valueChange.emit(entity.id);
        this.cd.detectChanges();
    };
    SisSingleSelectEntitySearchComponent.prototype.clearEntitySearchCtrl = function () {
        this.selectedEntity = null;
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.totalRows = 0;
        this.entities = [];
        this.entitySearchCtrl.setValue('');
        this.valueChange.emit(null);
        this.entityChange.emit(null);
    };
    SisSingleSelectEntitySearchComponent.prototype.openEntityList = function () {
        this.entitiesListMenuWidth = +document.getElementById('entitiesFormFiled').offsetWidth;
    };
    __decorate([
        core_1.ViewChild('entitiesInput'),
        __metadata("design:type", core_1.ElementRef)
    ], SisSingleSelectEntitySearchComponent.prototype, "entitiesInput", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisSingleSelectEntitySearchComponent.prototype, "entityChange", void 0);
    SisSingleSelectEntitySearchComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-singleselect-entity-search',
            styles: [require('./sis-singleselect-entity-search.component.css')],
            template: require('./sis-singleselect-entity-search.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Single Select Entity Search',
            settings: {
                main: sis_single_select_entity_search_settings_component_1.SisSingleSelectEntitySearchSettingsComponent
            },
            template: "\n                      <sis-singleselect-entity-search\n                        [id]=\"'%{id}'\"\n                        [(value)]=\"%{field}\"\n                        [filterableEntity]=\"'%{field-category}'\"\n                        [filterFields]=\"%{filterFields}\">\n                      </sis-singleselect-entity-search>\n                    ",
            defaultActions: {
                'filterFields': 'nameMetaFields-async'
            },
            isFieldBound: true,
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService, entity_service_1.EntitySearchService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider, core_1.ChangeDetectorRef,
            idm_message_language_service_client_js_1.LanguageService])
    ], SisSingleSelectEntitySearchComponent);
    return SisSingleSelectEntitySearchComponent;
}(sis_entity_search_component_1.SisEntitySearchComponent));
exports.SisSingleSelectEntitySearchComponent = SisSingleSelectEntitySearchComponent;
//# sourceMappingURL=sis-singleselect-entity-search.component.js.map